import React from "react";
import { Skeleton } from "src/Components/ui/skeleton";
import { Card, CardContent, CardHeader } from "src/Components/ui/card";

// Skeleton component for OrderRow that matches the exact design
function OrderRowSkeleton() {
  return (
    <Card className="border-2">
      <CardHeader className="pb-3">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-4 flex-1">
            <Skeleton className="w-16 h-16 rounded-xl shrink-0" /> {/* Icon */}
            <div className="flex-1 space-y-2">
              <Skeleton className="h-6 w-32" /> {/* Order title */}
              <Skeleton className="h-4 w-24" /> {/* Order type */}
            </div>
          </div>
          <Skeleton className="w-20 h-6 rounded-full" /> {/* Status badge */}
        </div>
      </CardHeader>
      <CardContent className="p-6 pt-4">
        {/* Order Details Grid Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {/* Basic Info Skeleton */}
        <div className="space-y-3">
          <Skeleton className="h-20 rounded-lg" /> {/* Final Total Card */}
          <Skeleton className="h-20 rounded-lg" /> {/* Sub Total Card */}
          <Skeleton className="h-16 rounded-lg" /> {/* Payment Method Card */}
        </div>
        {/* Order Type Specific Info Skeleton */}
        <div className="space-y-3">
          <Skeleton className="h-16 rounded-lg" />
          <Skeleton className="h-16 rounded-lg" />
          <Skeleton className="h-20 rounded-lg" />
        </div>
        {/* Contact & Time Info Skeleton */}
        <div className="space-y-3">
          <Skeleton className="h-16 rounded-lg" />
          <Skeleton className="h-16 rounded-lg" />
          <Skeleton className="h-16 rounded-lg" />
          <Skeleton className="h-20 rounded-lg" />
        </div>
      </div>

      <div className="h-px bg-border my-4" />

      {/* Status Update Section Skeleton */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <Skeleton className="w-32 h-10 rounded-md" />
        <div className="flex items-center gap-3 flex-1">
          <Skeleton className="w-24 h-4" />
          <Skeleton className="w-48 h-10 rounded-md" />
        </div>
      </div>
      </CardContent>
    </Card>
  );
}

export default OrderRowSkeleton;
